<div class="navigation-details-panel"
     [ngClass]="[shouldAdjust ? 'sidebar-adjust-header' : '', extraClass || '']">
  <ng-content select="[header-left]"></ng-content>
  <ng-content select="[header-center]"></ng-content>
  <ng-content select="[header-right]"></ng-content>
  <ng-content></ng-content>
</div>
